import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.scss';
import clsx from 'clsx';
import CheckMark from './CheckMark';

export const PhoneInputComponent = (
  { value, onChange, defaultCountry, onFocus, onBlur, isValid = true, displayCheckMark}) => {
  return (
    <div className="flex items-center relative w-full mt-2">
      <PhoneInput
        inputProps={{
          name: 'phone-number-input-drawer'
        }}
        value={value}
        onChange={onChange}
        country={defaultCountry || 'fr'}
        countryCodeEditable={false}
        containerClass="phone-input-container"
        enableLongNumbers={true}
        inputClass={clsx('phone-input-field', { 'invalid': !isValid })}
        buttonClass="phone-input-button"
        dropdownClass="phone-input-dropdown"
        containerStyle={{
          width: '100%',
        }}
        inputStyle={{
          width: '100%',
          height: '64px',
          fontSize: '16px',
          paddingLeft: '60px',
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          fontFamily: 'inherit',
        }}
        buttonStyle={{
          border: '1px solid #e0e0e0',
          borderRadius: '8px 0 0 8px',
          backgroundColor: 'white',
          height: '56px',
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        dropdownStyle={{
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}
      />

      <CheckMark show={displayCheckMark} />
    </div>

  );
};
